import { Loader2 } from "lucide-react";

export default function Spinner({ size = "md", className = "" }) {
  const sizeMap = { sm: "h-4 w-4", md: "h-6 w-6", lg: "h-10 w-10" };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader2 className={`${sizeMap[size]} animate-spin text-primary-500`} />
    </div>
  );
}

/** Full-page centered spinner with optional message */
export function PageSpinner({ message }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] gap-3">
      <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
      {message && <p className="text-sm text-neutral-400">{message}</p>}
    </div>
  );
}
